if (!window.FoxThemeCardVariantPickerInitialized) {
  window.FoxThemeCardVariantPickerInitialized = true;

  const variantsCache = new WeakMap();
  const saleBadgesCache = new WeakMap();

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const formatMoney = (value) => {
    const cents = Number(value) || 0;
    if (window.FoxTheme?.Currency?.formatMoney) {
      return window.FoxTheme.Currency.formatMoney(cents, window.FoxTheme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  };

  const getVariantsForCard = (card) => {
    if (variantsCache.has(card)) return variantsCache.get(card);

    const variantJson = card.querySelector('[data-card-variants]');
    if (!variantJson) return null;

    let variants = null;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (error) {
      console.error('Could not parse variants JSON:', error);
    }

    variantsCache.set(card, variants);
    return variants;
  };

  const setText = (el, value) => {
    if (el) el.textContent = value;
  };

  const getSaleBadgesForCard = (card) => {
    if (saleBadgesCache.has(card)) return saleBadgesCache.get(card);

    const badgesJson = card.querySelector('[data-card-sale-badges]');
    if (!badgesJson) return null;

    let badges = null;
    try {
      badges = JSON.parse(badgesJson.textContent);
    } catch (error) {
      console.error('Could not parse sale badges JSON:', error);
    }

    saleBadgesCache.set(card, badges);
    return badges;
  };

  const updateCardBadge = (card, variant) => {
    const badgeEl = card.querySelector('.product-card__badge .f-badge--sale');
    if (!badgeEl || !variant) return;

    const badges = getSaleBadgesForCard(card);
    const badgeHtml = badges ? badges[variant.id] : null;

    badgeEl.classList.toggle('hidden', badgeHtml == null);
    if (badgeHtml != null) badgeEl.innerHTML = badgeHtml;
  };

  const updateCardPrice = (card, variant) => {
    const price = card.querySelector('.f-price');
    if (!price || !variant) return;

    const variantPrice = Number(variant.price) || 0;
    const compareAtPrice = Number(variant.compare_at_price) || 0;
    const onSale = compareAtPrice > variantPrice;

    price.classList.toggle('f-price--on-sale', onSale);
    price.classList.toggle('f-price--sold-out', !variant.available);

    const regularPrice = price.querySelector('.f-price__regular .f-price-item--regular');
    const salePriceEl = price.querySelector('.f-price__sale .f-price-item--sale');
    const comparePriceEl = price.querySelector('.f-price__sale .f-price-item--regular s');

    setText(regularPrice, onSale ? '' : formatMoney(variantPrice));
    setText(salePriceEl, onSale ? formatMoney(variantPrice) : '');
    setText(comparePriceEl, onSale ? formatMoney(compareAtPrice) : '');
  };

  const updateCardUnitPrice = (card, variant) => {
    const unitWrapper = card.querySelector('.f-price__unit-wrapper');
    if (!unitWrapper) return;

    const measurement = variant?.unit_price_measurement;
    unitWrapper.classList.toggle('hidden', measurement == null);
    if (measurement == null) return;

    const unitPriceEl = unitWrapper.querySelector('[data-unit-price]');
    const baseUnitEl = unitWrapper.querySelector('[data-unit-price-base-unit]');

    setText(unitPriceEl, formatMoney(variant.unit_price));
    setText(
      baseUnitEl,
      `${measurement.reference_value !== 1 ? measurement.reference_value : ''}${measurement.reference_unit || ''}`
    );
  };

  const getSelectedVariantFromCard = (card) => {
    const variants = getVariantsForCard(card);
    if (!variants) return null;

    const variantSelects = card.querySelector('variant-selects');
    if (!variantSelects) return null;

    const selectedValues = Array.from(variantSelects.querySelectorAll('select, fieldset')).map((element) => {
      if (element.tagName === 'SELECT') {
        return normalize(element.value);
      }
      const checked = element.querySelector('input:checked');
      return normalize(checked?.value);
    });

    return (
      variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.every((optionValue, index) => normalize(optionValue) === selectedValues[index]);
      }) || null
    );
  };

  document.addEventListener('change', (event) => {

    if (!event.target.matches('select, input[type="radio"], input[type="checkbox"]')) return;

    const variantSelects = event.target.closest('variant-selects');
    if (!variantSelects) return;

    const card = event.target.closest('.product-card');
    if (!card) return;

    const selectedVariant = getSelectedVariantFromCard(card);

    const variantInputs = card.querySelectorAll('input.product-variant-id[name="id"]');
    const isZeroPrice = Boolean(selectedVariant) && Number(selectedVariant.price) === 0;
    variantInputs.forEach((input) => {
      if (selectedVariant) {
        input.value = selectedVariant.id;
      }
      input.disabled = !selectedVariant?.available || isZeroPrice;
    });

    card.querySelectorAll('[name="add"]').forEach((button) => {
      button.disabled = !selectedVariant?.available || isZeroPrice;
    });

    if (!selectedVariant) return;

    updateCardPrice(card, selectedVariant);
    updateCardUnitPrice(card, selectedVariant);
    updateCardBadge(card, selectedVariant);

    card.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: { variant: selectedVariant, card },
      })
    );
  });
}